export const uk = {
    'default-error': 'Некорректно заполнены данные'
};
